/**
 * 用户登录权限api接口
 * @author： xuyd
 * @date：2022-09-02
 * Copyright (c) 2022 fxwiz all rights reserved.
 */
import request from "../utils/request.js"

import {context} from '@/config/env.js'
const uamsAdminModule = context.uamsAdmin
const serviceModule = context.sunflower

/**
 * 用户退出
 */
export const logout = () => {
  return request.post(serviceModule + "/uams/logout");
};

/**
 * 用户session
 */
export const getUserSession = () => {
  return request.get(serviceModule + "/uams/session/find");
};

/**
 * 当前用户信息
 */
export const getProfile = (username) => {
  return request.post(uamsAdminModule + "/uams/user/get?username=" + username);
}

/**
 * 用户菜单路由数据
 * @param appGuid {appGuid} 模块区分
 * @return
 */
export const getMenuRouteList = () => {
  let params = {appGuid: 'sunflower-api'}
  return request.get(uamsAdminModule + "/menu/routes/get", {params});
};

/**
 * 用户检索
 * @return
 */
export const searchUserList = () => {
  return request.post(uamsAdminModule + "/uams/user/search");
}
